var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconTag = function SvgIconTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.04 7.307-2.665-4a1.246 1.246 0 0 0-1.042-.557H1.5a.75.75 0 0 0-.617 1.176L3.695 8 .883 12.074A.75.75 0 0 0 1.5 13.25h9.833a1.245 1.245 0 0 0 1.042-.557l2.667-4a1.246 1.246 0 0 0-.002-1.386ZM11.2 11.75H2.93l2.103-3.046a1.244 1.244 0 0 0 0-1.408L2.93 4.25h8.27L13.7 8l-2.5 3.75Z"
  })));
};

export default SvgIconTag;